/**
 * The signature block.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readArray, readString } from '@/domain/json'
import type { JsonValue } from '@/domain/json'
import { newId, newSignatory, type Signatory, type SignaturesSection } from '@/domain/section'
import SignaturesBlock from '@/sections/signatures/SignaturesBlock.vue'
import SignaturesInspector from '@/sections/signatures/SignaturesInspector.vue'
import type { SectionDefinition } from '@/sections/types'

function readSignatory(value: JsonValue): Signatory {
  return {
    id: readString(value, 'id') || newId(),
    name: readString(value, 'name'),
    role: readString(value, 'role'),
    place: readString(value, 'place'),
  }
}

export const signaturesSection: SectionDefinition<'signatures', SignaturesSection> = {
  kind: 'signatures',
  band: 'frontAndBack',

  icon: ['M3 10.5c2-3.5 3.5 1 5.5-1.5S11 6 13 8.5', 'M3 13h10'],

  create: (id, title) => ({
    id,
    kind: 'signatures',
    title,
    signatories: [newSignatory()],
    statement: '',
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'signatures',
    title,
    signatories: readArray(stored, 'signatories').map(readSignatory),
    statement: readString(stored, 'statement'),
  }),

  block: SignaturesBlock,
  inspector: SignaturesInspector,
}
